import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Footer from './components/Footer';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Productoverview from './components/Product_pages/Productoverview';
import Whatnew from './components/Product_pages/Whatsnew';
import Demo from './components/Demo';
import Support from './components/Support';
import Productcreation from './components/Instant_Demos/Productcreation';
import Pricing from './components/Pricing';
import Trial from './components/Trial';
import Features from './components/Features';
import Download from './components/Download';
import Supermarket from './components/Supermarket';
import AuditusierpDemo from './components/AuditusierpDemo';
import Brochure from './components/Brochures/Brochure';
import SupportWidget from './components/SupportWidget';

/* ── Scroll to top on every route change ── */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const location = useLocation();

  // Define base paths for which the navbar/footer should be hidden
  // These are the *starts* of the paths you want to hide
  const pathsToHideNavbar = ['/creation', '/auditusierp_demo', '/brochure']; // If any path starts with /creation
  const pathsToHideFooter = ['/creation', '/industrial-specification', '/auditusierp_demo','/brochure']; // If any path starts with these

  // Get the current path and normalize it (lowercase)
  const currentPath = location.pathname.toLowerCase();

  // Check if the current path starts with any of the paths in the hide list
  const shouldHideNavbar = pathsToHideNavbar.some(path => currentPath.startsWith(path));
  const shouldHideFooter = pathsToHideFooter.some(path => currentPath.startsWith(path));

  return (
    <div className="App">
      {/* Conditionally render Navbar */}
      {!shouldHideNavbar && (
        <div className="nav_gap">
          <Navbar />
        </div>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Productoverview" element={<Productoverview />} />
        <Route path="/whatsnew" element={<Whatnew />} />
        <Route path="/Trial" element={<Trial />} />
        <Route path="/Demo" element={<Demo />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/Support" element={<Support />} />
        <Route path="/Features" element={<Features />} />
        {/* Routes for Productcreation */}
        <Route path="/creation/:creationSlug" element={<Productcreation />} />
        <Route path="/creation" element={<Productcreation />} /> {/* Keep this for /creation path without slug */}
  {/* AuditusierpDemo route */}
  <Route path="/Auditusierp_demo" element={<AuditusierpDemo />} />
        {/* Supermarket route */}
        <Route path="/Industrial-specification" element={<Supermarket />} />
        <Route path="/Download" element={<Download />} />
        <Route path="/Brochure" element={<Brochure />} />
      </Routes>
      {/* Conditionally render Footer */}
      {!shouldHideFooter && <Footer />}
      <SupportWidget />
    </div>
  );
}

export default function MainApp() {
  return (
    <Router>
      <ScrollToTop />
      <App />
    </Router>
  );
}